import { useQuery } from '@tanstack/react-query';

import { accountUserDetailKey } from '../common/queryKeys';
import AccountUserApi from '../../../../../lib/api/account/user/AccountUserApi';
import { setRequestForm } from '../../../../../lib/common';

export const useAccountUserDetailTagListQuery = ({ userId, sortOption, filterOption, options }) => {
  return useQuery(
    [...accountUserDetailKey, 'tagList', userId, sortOption, filterOption],
    async () => {
      const result = await AccountUserApi.getAccountUserTagDetail(
        setRequestForm({ userId, tagHistory: { sortOption, filterOption } }, true),
      );
      if (result.msg) throw new Error(result.msg);
      return result;
    },
    {
      ...options,
      initialData: { data: { tagHistoryList: { list: [], totalCnt: 0 } } },
    },
  );
};
